<div class="flex flex-row justify-end items-center">
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon class="close-icon" color="accent">close</mat-icon>
    </button>
</div>

<h1 mat-dialog-title class="font-extrabold text-2xl text-center">{{isAppel ?
    utils.traslatei18n( 'Create_appeal_survey')
    :
    utils.traslatei18n( 'Interview detail')}}</h1>
<h2 class="text-base font-normal text-center">
    {{clientDetails.surveyRequestId}}</h2>

<mat-dialog-content class="interviewDetailDialogContent">

   

    <app-interview-detail *ngIf="showInterview"
        [interviewDetail]="clientDetails"
        [questions]="allQuestions">

    </app-interview-detail>

</mat-dialog-content>
